<script setup lang="ts">
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/cn';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'success' | 'ai';
type Size = 'sm' | 'md' | 'lg';

const button = cva(
  'inline-flex items-center justify-center gap-2 font-medium tracking-tight whitespace-nowrap transition-colors disabled:opacity-50 disabled:pointer-events-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy-600',
  {
    variants: {
      variant: {
        primary:   'bg-navy-800 text-white hover:bg-navy-900',
        secondary: 'bg-surface text-fg border border-border hover:bg-canvas-soft',
        ghost:     'text-muted hover:bg-canvas-soft hover:text-fg',
        danger:    'bg-red-600 text-white hover:bg-red-700',
        success:   'bg-green-600 text-white hover:bg-green-700',
        ai:        'bg-teal-600 text-white hover:bg-teal-700',
      },
      size: {
        sm: 'h-8 px-2.5 text-caption rounded-sm',
        md: 'h-9 px-3 text-body rounded-md',
        lg: 'h-11 px-5 text-body rounded-lg',
      },
      block: { true: 'w-full' },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  }
);

interface Props {
  variant?: Variant;
  size?: Size;
  block?: boolean;
  loading?: boolean;
  class?: string;
}

const props = defineProps<Props>();
</script>
<template>
  <button :class="cn(button({ variant, size, block }), props.class)" :disabled="loading">
    <slot name="left" />
    <slot />
    <slot name="right" />
  </button>
</template>
